"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadePickerDialog = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../api");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _shouldFetchShades = require("../../utils/shouldFetchShades");
var _GoToProduct = require("../GoToProduct");
var _Loading = require("../Loading");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ShadePickerProducts = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require('../Products')))).Products
}));
/**
 * Shows Shade Picker dialog.
 */
const ShadePickerDialog = ({
  mode,
  open,
  onClose,
  goToUrl,
  products,
  productName,
  placement,
  productCode,
  productListId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const enabled = (0, _shouldFetchShades.shouldFetchShades)({
    productCode,
    products
  });
  const {
    loading,
    data
  } = (0, _api.useGetProductShades)({
    productCode,
    enabled
  });
  const footer = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_GoToProduct.GoToProduct, {}), []);
  const isLoading = loading && enabled;
  const value = (0, _react.useMemo)(() => ({
    mode,
    placement,
    productCode,
    goToUrl: enabled ? data?.goToUrl : goToUrl,
    products: enabled ? data?.products : products,
    productName: enabled ? data?.productName : productName,
    productListId
  }), [mode, placement, productCode, enabled, data?.goToUrl, data?.products, data?.productName, goToUrl, products, productName, productListId]);
  const content = (0, _react.useMemo)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}),
    children: isLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(ShadePickerProducts, {})
  }), [isLoading]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.ShadePickerProvider, {
    value: value,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDialog, {
      drawer: true,
      disableEnforceFocus: true,
      "data-testid": getTestId(_constants.SHADE_PICKER_DIALOG),
      zIndex: theme.zIndex.modal + 1,
      open: open,
      size: "small",
      transitionProps: _constants.transitionProps,
      header: translations.chooseShade,
      footer: footer,
      onClose: onClose,
      children: content
    })
  });
};
exports.ShadePickerDialog = ShadePickerDialog;
